var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-card-text',{staticClass:"white--text text-center text-h5 primary"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }